<script lang="ts">
    interface Props {
        headline: string;
        subheadline: string;
        image: string;
        /*                                                        */
        id: string;
        listPosition: number;
        localListPosition: number;
    }

    let { headline, subheadline, image, id, listPosition, localListPosition }: Props = $props();
</script>

<article class="reptile-combo-tile" data-list-position={listPosition} data-local-list-position={localListPosition}>
    <button
        data-oc-sheet-v1-open={'{"id": "reptile-inspiration-combination-sheet"}'}
        class="reptile-combo-tile__button"
        aria-labelledby={id}
    ></button>
    <div class="reptile-combo-tile__container">
        <picture class="reptile-combo-tile__picture">
            <img
                class="reptile-combo-tile__image"
                loading="lazy"
                src={image}
                alt="Beispielbild zur vorgeschlagenen Produktkombination"
            />
        </picture>
        <div class="reptile-combo-tile__header" {id}>
            <h2 class="reptile-combo-tile__headline">{headline}</h2>
            <!-- An oc-media-object-card would be the designsystem-correct container here (has this
                 action signifier built in), but its layout is a fixed-height row with a square
                 image thumbnail beside the text, not a full-bleed background image with an
                 overlaid gradient - see https:/*                                                                                                         */
            <!-- oc-action-signifier-v1 only underlines its text in the inverted variant, so it
                 doesn't match this subheadline's always-underlined look - styled manually instead -->
            <p class="reptile-combo-tile__subheadline">
                <span class="reptile-combo-tile__subheadline-text">{subheadline}</span>
                <oc-icon-v1 type="arrow-right" size={'50'}></oc-icon-v1>
            </p>
        </div>
    </div>
</article>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;

    .reptile-combo-tile {
        --border-radius: #{tokens.$oc-semantic-border-radius-200};

        isolation: isolate;
        position: relative;

        /*                                                                                                                        */
        overflow: hidden;

        width: 100%;
        height: 100%;
        border-radius: var(--border-radius);

        &__button {
            cursor: pointer;

            position: absolute;
            z-index: 2;

            width: 100%;
            height: 100%;
            padding: 0;
            border: none;

            background: none;
        }

        &__container {
            display: grid;
            grid-template-rows: 1fr max-content;
            height: 100%;
        }

        &__picture {
            grid-column: 1;
            grid-row: 1 / -1;
            width: 100%;
            height: 100%;
        }

        &__image {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        &__header {
            display: flex;
            grid-column: 1;
            grid-row: 2 / -1;
            flex-direction: column;
            gap: tokens.$oc-semantic-spacing-absolute-25;

            padding: tokens.$oc-semantic-spacing-absolute-150 tokens.$oc-semantic-spacing-absolute-100
                tokens.$oc-semantic-spacing-absolute-100;
            border-radius: 0 0 var(--border-radius) var(--border-radius);

            background: linear-gradient(
                180deg,
                rgb(255 255 255 / 0%) 0%,
                rgb(255 255 255 / 54%) 20%,
                rgb(255 255 255 / 54%) 100%
            );
            /*                                                                                               */
            backdrop-filter: blur(4px);
        }

        &__headline {
            font: tokens.$oc-semantic-font-headline-300;
        }

        &__subheadline {
            display: flex;
            gap: tokens.$oc-semantic-spacing-absolute-25;
            align-items: center;
            margin: 0;
        }

        &__subheadline-text {
            font: tokens.$oc-semantic-font-copy-75;
            font-weight: tokens.$oc-base-font-weight-bold;
            text-decoration: underline;
        }
    }
</style>
